// ── Generic grouping ────────────────────────────────────────────────────────
export const countBy = (arr, field) => {
  const counts = {};
  (arr || []).forEach((item) => {
    let key = item[field];
    if (!key || key === "-") key = "Unassigned";
    counts[key] = (counts[key] || 0) + 1;
  });
  return Object.entries(counts).map(([name, value]) => ({ name, value }));
};

// ── Age ──────────────────────────────────────────────────────────────────

export const calcAge = (dob) => {
  if (!dob) return null;
  const birth = new Date(dob);
  if (isNaN(birth.getTime())) return null;
  const diff = Date.now() - birth.getTime();
  return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
};

export const AGE_BUCKETS = [
  { label: "Under 25", min: 0, max: 24 },
  { label: "25–34", min: 25, max: 34 },
  { label: "35–44", min: 35, max: 44 },
  { label: "45–54", min: 45, max: 54 },
  { label: "55+", min: 55, max: 200 },
];

export const buildAgeGroups = (employeesWithAge) =>
  AGE_BUCKETS.map((bucket) => ({
    name: bucket.label,
    value: employeesWithAge.filter((e) => e.age >= bucket.min && e.age <= bucket.max).length,
  }));



export const buildJoiningTrend = (employees) => {
  const counts = {};
  (employees || []).forEach((e) => {
    if (!e.joinDate) return;
    const year = new Date(e.joinDate).getFullYear();
    if (isNaN(year)) return;
    counts[year] = (counts[year] || 0) + 1;
  });
  return Object.keys(counts)
    .sort()
    .map((year) => ({ name: year, Joined: counts[year] }));
};


const BANK_ID_KEYS = ["HBD_BANK_ID", "BankId", "bankId"];
const BANK_NAME_KEYS = ["HBD_BANK_NAME", "BankName", "bankName"];
const BRANCH_BANKID_KEYS = ["BankId", "bankId", "p_bankId", "HBD_BANK_ID"];


export const buildBranchesByBank = (banks, branches, pick, getRowName, getRowCode) => {
  const bankNameById = {};
  (banks || []).forEach((b) => {
    const id = String(pick(b, BANK_ID_KEYS, ""));
    if (id) bankNameById[id] = getRowName(b, BANK_NAME_KEYS) || getRowCode(b, []) || "Unnamed Bank";
  });

  const counts = {};
  (branches || []).forEach((br) => {
    const bankId = String(pick(br, BRANCH_BANKID_KEYS, ""));
    const name = bankNameById[bankId] || "Unmatched Bank";
    counts[name] = (counts[name] || 0) + 1;
  });

  return Object.entries(counts)
    .map(([name, value]) => ({ name, value }))
    .sort((a, b) => b.value - a.value);
};

// ── Attendance / Leave mock data ─────────────────────────────────────────